import { render } from "./CustomBlock.vue?vue&type=template&id=010bbb06&scoped=true"
import script from "./CustomBlock.vue?vue&type=script&lang=js"
export * from "./CustomBlock.vue?vue&type=script&lang=js"

import "./CustomBlock.vue?vue&type=style&index=0&id=010bbb06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010bbb06"]])

export default __exports__